import {Component, OnInit} from '@angular/core';
import Cookie from 'js-cookie';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {environment} from 'src/environments/environment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {emailValidator} from '../../../services/app-validators';
import {Contact} from '../../../classes/app.models';
import {finalize} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';
import {Router} from '@angular/router';
import { ModalService } from 'src/app/shared/services/modal.service';


@Component({
    selector: 'indiapicture-newsletter-modal',
    templateUrl: './newsletter-modal.component.html',
    styleUrls: ['./newsletter-modal.component.scss']
})

export class NewsletterModalComponent implements OnInit {

    checkState = false;
    contactForm: FormGroup;

    constructor(private modalService: NgbActiveModal, private formBuilder: FormBuilder, private toastrService: ToastrService,
                private apiService: ApiService, private router: Router, private cashModalService: ModalService) {
    }

    ngOnInit(): void {
        this.contactForm = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required])],
            name: ['', Validators.compose([Validators.required])],
            contact: ['', Validators.compose([Validators.required])],
            requirement: ['', Validators.compose([Validators.required])],
            subject: ['Get cashback Form'],
            page_url: ['']
        });
    }

    public onSubmit(): void {
        if (this.contactForm.invalid || this.contactForm.pristine) {
            this.toastrService.error('All required fields must be filled out to continue.');
            return;
        }
        this.contactForm.disable();

        let element: Contact = new Contact();
        element = Object.assign({}, element, this.contactForm.value);
        element.page_url = this.router.url;

        this.apiService.addQueryForm(element)
            .pipe(
                finalize(() => {
                    this.contactForm.enable();
                })
            )
            .subscribe(
                res => {
                    this.toastrService.success('Thank you for sharing your details. Our Relationship Manager will get in touch with you soon!');
                this.cashModalService.closeCashBack();
                },
                err => {
                 //  console.log('error: ', err);
                    // this.errorSubject.next(error);
                    // this.loadingSubject.next(false);
                    this.toastrService.error('There is some error');
                });
    }


    changeCheck() {
        this.checkState = !this.checkState;
    }

    closeModal() {
        this.modalService.dismiss();
        this.checkState && Cookie.set(`hideNewsletter-${environment.demo}`, 'true', {expires: 7});
    }
}
